/**
 * CollectionSwitcher — top-level switch between the user's uploaded files and
 * the system-generated document collections (Invoices, Bills). A segmented
 * control, the documents analogue of a Dropbox sidebar section.
 */
import { FolderOpen, Receipt, ShoppingCart } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@flint/ui";

export type Collection = "files" | "invoices" | "bills";

const OPTIONS: ReadonlyArray<{ id: Collection; label: string; icon: LucideIcon }> = [
  { id: "files", label: "My files", icon: FolderOpen },
  { id: "invoices", label: "Invoices", icon: Receipt },
  { id: "bills", label: "Bills", icon: ShoppingCart },
];

export function CollectionSwitcher({
  value,
  onChange,
}: {
  value: Collection;
  onChange: (c: Collection) => void;
}) {
  return (
    <div className="inline-flex rounded-md border border-line bg-paper p-0.5 shadow-sm">
      {OPTIONS.map((o) => {
        const active = o.id === value;
        const Icon = o.icon;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            aria-pressed={active}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-[5px] px-3 py-1.5 text-sm font-medium transition-colors",
              active ? "bg-ink text-paper shadow-sm" : "text-ink-2 hover:bg-bg",
            )}
          >
            <Icon size={14} strokeWidth={2} aria-hidden />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
